import { Grid } from "@material-ui/core";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { GENDER_LIST } from "../../../../LocalConstants";
import { getDate, getDateTime, hideMiddleDigits } from "../../../../common/LocalFunction";
import TableComponent from "../../../../common/Component/Table/TableComponent";

function ClientList () {
  const {t} = useTranslation ();
  const {values} = useFormikContext ();
  let columns = [
    {
      title:t ("Mã khách hàng"),
      field:"code",
      width:"150",
    },
    {
      title:t ("Tên khách hàng"),
      field:"fullName",
      width:"150",
    },

    {
      title:"Số điện thoại",
      field:"phoneNumber",
      render:(rowData) => {
        return (
            <div style={{display:"flex", flexDirection:"column", gap:4}}>
            <span>
              {" "}
              {hideMiddleDigits(rowData?.phoneNumber)}
            </span>
              {rowData?.phoneNumber2 && (
                  <span>
                  {hideMiddleDigits(rowData?.phoneNumber2)}
              </span>
              )}
              {rowData?.phoneNumber3 && (
                  <span>
                  {hideMiddleDigits(rowData?.phoneNumber3)}
              </span>
              )}
              {rowData?.phoneNumber4 && (
                  <span>
                  {hideMiddleDigits(rowData?.phoneNumber4)}
              </span>
              )}
            </div>
        );
      },
    },
    {
      title:t ("Giới tính"),
      field:"gender",
      width:"150",
      render:(rowData) => {
        return GENDER_LIST.find ((item) => item?.value === rowData?.gender)?.name;
      },
    },
    {
      title:"Ngày sinh nhật",
      field:"birthDate",
      width:"50",
      render:(rowData) => {
        return getDate (rowData.birthDate);
      },
    },
    {
      title:"Ngày tạo",
      field:"clientCreateDate",
      width:"50",
      render:(rowData) => {
        return getDateTime (rowData.clientCreateDate);
      },
    },
    {
      title:t ("Cơ sở"),
      field:"facility.name",
      width:"150",
    },
    {
      title:"Địa chỉ",
      field:"address",
      hidden:true,
      render:(rowData) => {
        let address = "";
        if (rowData?.currentDetailResidence) {
          address = rowData?.currentDetailResidence;
        }

        if (rowData?.currentWard?.name) {
          address += (address? ", " : "") + rowData?.currentWard?.name;
        }

        if (rowData?.currentDistrict?.name) {
          address += (address? ", " : "") + rowData?.currentDistrict?.name;
        }

        if (rowData?.currentProvince?.name) {
          address += (address? ", " : "") + rowData?.currentProvince?.name;
        }
        return address || "";
      },
    },
  ];

  return (
      <section className="cards-container">
        {/*<h4 className="cards-header">{"Danh sách cơ sở thuộc nhóm"}</h4>*/}
        <div className="cards-body">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TableComponent
                  showOrdinalNumbers
                  data={values?.clients || []}
                  columns={columns}
                  noPagination={true}
              />
            </Grid>
          </Grid>
        </div>
      </section>
  );
}

export default memo (observer (ClientList));
